// External libs
import { createSelector } from 'reselect';
// Interfaces
import { State } from '../interfaces';
import { SupportSuggestion } from '../../../interfaces';

const selectSlice: (state: any) => State = (state: any) =>
  state.noRTSupportSuggestions;

const selectDescription = createSelector<any, State, string>(
  selectSlice,
  reducer => reducer.description,
);

const selectOrderId = createSelector<any, State, number>(
  selectSlice,
  reducer => reducer.orderId,
);

const selectSupportSuggestions = createSelector<
  any,
  State,
  SupportSuggestion[]
>(
  selectSlice,
  reducer => reducer.supportSuggestions,
);

const selectors = {
  selectDescription,
  selectOrderId,
  selectSupportSuggestions,
};

export default selectors;
